<template>
  <highcharts
    ref="chart"
    style="height:19px; width:60px;"
    :options="chartOptions"
  ></highcharts>
</template>

<script>
import {Chart as highcharts} from "highcharts-vue";
import styles from "@/assets/css/common.scss";

export default {
  name: "ElementsTreeMiniChart",
  components: {highcharts},
  props: {
    node: { type: Object, required: true },
    prop: { type: String, required: true },
    type: { type: String, default: "area" },
    min: { type: Number },
    max: { type: Number },
  },
  computed: {
    chartOptions() {
      return {
        exporting: false,
        chart: {
          type: this.type,
          backgroundColor: 'rgba(0,0,0,0)',
          marginTop: 0,
          marginBottom: 0,
          marginLeft:0,
          marginRight:0,
          plotShadow: false,
          borderWidth: 0,
          plotBorderWidth: 0,
        },
        tooltip: {enabled: false},
        title: {text: ''},
        xAxis: {
          // enabled:false,
          // showEmpty:false,
        },
        yAxis: {
          min: this.min !== undefined ? this.min : null,
          max: this.max !== undefined ? this.max : null,
          title: {text: ''},
          // showEmpty:false,
        },
        credits: {enabled: false},
        legend: {enabled:false},
        plotOptions: {
          area:{color: styles.ColorPrimary},
          line:{
            lineWidth:1.5,
            color: styles.ColorPrimary
          },
          showInLegend: false,
          tooltip: {}
        },
        series: [{
          states: {
            hover: {
              enabled: false
            }
          },
          enableMouseTracking: false,
          marker: {
            enabled: false
          },
          animation:false,
          name: '',
          data: this.node.model[this.prop]
        }]
      }
    }
  },

  data() {
    return {};
  },

  methods: {}

};
</script>

<style lang="scss">
@import "@/assets/css/project-variables";

</style>